export default {
    driver_performance_cases_create_createCases: "Create Coaching Cases",
    driver_performance_cases_create_select: "Select",
    // Driver Scope Section
    driver_performance_cases_create_driverScope: "Driver Scope",
    driver_performance_cases_create_milesDriven: "Miles Driven",
    driver_performance_cases_create_milesDrivenDetail: "Include drivers that have traveled more than the selected distance.",
    driver_performance_cases_create_riskScore: "Risk Score",
    driver_performance_cases_create_riskScoreDetail: "Include drivers that have a Risk score greater than the selected value.",
    // Limited By Section
    driver_performance_cases_create_riskScoreGreater: "Risk Score Greater Than",
    driver_performance_cases_create_limitedBy: "Limited By",
    driver_performance_cases_create_lastCoached: "Last Coached (Days)",
    driver_performance_cases_create_lastCoachedDetail: "Omit drivers that have been coached within the selected value.",
    // Event Types to Include Section
    driver_performance_cases_create_eventTypesToInclude: "Event Types to Include",
    driver_performance_cases_create_eventStatusQueueForCoaching: "Event Status of Queue for Coaching",
    driver_performance_cases_create_eventStatusQueueForCoachingDetail: "Include Events that have a status of 'Queue for Coaching'",
    driver_performance_cases_create_severityScore: "Severity Score",
    driver_performance_cases_create_severityScoreDetail: "Include Events that have a Severity score greater than the selected value.",
    driver_performance_cases_create_byFrequency: "By Frequency",
    driver_performance_cases_create_byFrequencyDetail: "Include the most frequently occurring event types, up to the selected value",
    driver_performance_cases_create_noteEventsCaped: "Note: Selected Events will be capped at 100 per Driver",
    // Limit Examples Section
    driver_performance_cases_create_limitExamples: "Limit Examples",
    driver_performance_cases_create_maximumEventsPerEventType: "Maximum Events per Event Type",
    driver_performance_cases_create_maximumEventsPerEventTypeDetail: "Maximum number of examples per Event type",
    // Common
    driver_performance_cases_create_all: "All",
    driver_performance_cases_create_miles: "Miles",
    driver_performance_cases_create_kilometers: "Kilometers",
    driver_performance_cases_create_note: "Note",
    driver_performance_cases_create_eventNote: "Events, associated to Drivers with active Coaching Cases, will be added to those cases.",
    driver_performance_cases_create_send: "Send",
    driver_performance_cases_create_saveSuccessfully: "Start process to bulk coaching generates cases automatically has started successfully.",
    driver_performance_cases_create_saveError: "An error occurred creating cases",
    driver_performance_cases_all: "All",
    driver_performance_cases_create_kilometersDriven: "Kilometers Driven",
};
